import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthContext';

function AgentRedirect() {
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        // Redirect to admin agents page if user is admin, otherwise redirect to home
        if (user && user.admin) {
            navigate('/admin/agents/manage', { replace: true });
        } else {
            // Non-admin users should not access agent management
            navigate('/', { replace: true });
        }
    }, [user, navigate]);

    return <div>Redirecting...</div>;
}

export default AgentRedirect;
